import i18next from 'i18next'
import React, { useEffect } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import STORAGEKEY from '../config/APP/app.config'
import EmoployerOutlet from '../employer/EmoployerOutlet'
import AddTrainingPartner from '../employer/Job/AddTrainingPartner'
import JobApplication from '../employer/Job/JobApplication'
// import PostJob from '../employer/PostJob'
import { ApiGet, ApiGetNoAuth } from '../helper/API/ApiData'
import AuthStorage from '../helper/AuthStorage'
import PartnersLayout from '../layout/partners'
import Dashboard from './Dashboard'
import AddUpdateEnterprise from './Enterprise/AddUpdateEnterprise'
import EnterpriseList from './Enterprise/EnterpriseList'
import EnterpriseNavigation from './Enterprise/EnterpriseNavigation'
import { GroupMemberNavigation } from './GroupMember/GroupMemberNavigation'
import AddUpdateMember from './member/AddUpdateMember'
import { ListMember } from './member/ListMember'
import PartnersOutlet from '../partners/PartnersOutlet'
import AddUpdateShg from './shg/AddUpdateShg'
import { AddUpdateShgTraining } from './training/AddUpdateTraining'
import { ListShg } from './shg/ListShg'
import ShgDetailsNavigation from './shg/ShgDetailsNavigation'
import ShgTraining from './training/TrainingList'
import ShgAdminLayout from '../layout/shgAdmin'
import TrainingList from './training/TrainingList'


const index = () => {

    useEffect(() => {
        if (AuthStorage.getStorageData(STORAGEKEY.language) === null || AuthStorage.getStorageData(STORAGEKEY.language) === "null") {
            const lan = "English";
            ApiGetNoAuth(`language/getLanguageByName?name=${lan}`).then((res: any) => {
                AuthStorage.setStorageData(STORAGEKEY.language, res.data.id, true);
                AuthStorage.setStorageData(STORAGEKEY.lang, res.data.name.slice(0, 2).toLowerCase(), true);
            });
        }
    }, [AuthStorage.getStorageData(STORAGEKEY.language)])

    return (
        <ShgAdminLayout>
            <Routes>
                <Route path="/shgadmin" element={<Outlet />}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="member" element={<ListMember />} />
                    <Route path="member/add" element={<AddUpdateMember />} />

                    <Route path="shg" element={<ListShg />} />
                    <Route path="shg/add/" element={<AddUpdateShg />} />
                    <Route path="shg/:id/:type/:action/:itemId" element={<ShgDetailsNavigation />} />
                    <Route path="shg/:id/:type/:action/" element={<ShgDetailsNavigation />} />

                    <Route path="enterprise/" element={<EnterpriseList />} />
                    <Route path="enterprise/add" element={<AddUpdateEnterprise />} />
                    <Route path="enterprise/:id/:type/:action/:itemId" element={<EnterpriseNavigation />} />
                    <Route path="enterprise/:id/:type/:action" element={<EnterpriseNavigation />} />

                    <Route path="trainings" element={<TrainingList />} />
                    <Route path="trainings/add" element={<AddUpdateShgTraining />} />

                    <Route path="group_member/:group_member_id/" element={<GroupMemberNavigation />} />

                </Route>
            </Routes>
        </ShgAdminLayout>
    )
}

export default index